import React from 'react';
import { Heart, Camera, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 px-6 fade-in-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-6">
            About <span className="text-gold">Me</span>
          </h2>
        </div>
        
        {/* Small Profile Photo - Centered */}
        <div className="flex justify-center mb-12">
          <div className="relative w-48 h-48 overflow-hidden rounded-full border-4 border-gold/30">
            <img 
              src="/images/profile-photo.webp" 
              alt="Profile" 
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
            />
          </div>
        </div>
        
        <div className="space-y-8 text-lg text-gray-300 leading-relaxed">
          <p>
            I'm a creative leader with experience working inside boutique agency environments 
            where speed, collaboration, and strong visual direction are essential.
          </p>
          
          <p>
            My background spans graphic design, photography direction, campaign development, 
            and digital marketing production. That hands-on experience allows me to lead 
            creative teams effectively while maintaining a clear vision for the final work.
          </p>
          
          <p>
            I'm passionate about building ideas, guiding teams, and producing work that 
            elevates brands.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          <div className="text-center p-8 border border-gray-800 hover:border-gold transition-colors duration-300">
            <Heart className="text-magenta mx-auto mb-4" size={40} />
            <h3 className="font-bold text-xl mb-2">Passionate</h3>
            <p className="text-gray-400 text-sm">About building ideas that elevate brands</p>
          </div>
          <div className="text-center p-8 border border-gray-800 hover:border-gold transition-colors duration-300">
            <Camera className="text-gold mx-auto mb-4" size={40} />
            <h3 className="font-bold text-xl mb-2">Experienced</h3>
            <p className="text-gray-400 text-sm">In design, photography, and campaign development</p>
          </div>
          <div className="text-center p-8 border border-gray-800 hover:border-gold transition-colors duration-300">
            <TrendingUp className="text-magenta mx-auto mb-4" size={40} />
            <h3 className="font-bold text-xl mb-2">Results-Driven</h3>
            <p className="text-gray-400 text-sm">Focused on delivering high-standard work</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;